export const navFilter= (value, type) => {
    if(type.name !== 'Array'){
        console.error('navFilter expects Array as the type');
    }
    let array = JSON.parse(value);
    let filtered = [];
    array.forEach((item)=>{
        if(Array.isArray(item)){
            let sub = [];
            item.forEach(_sub=>{
                if(_sub.url&&_sub.title){
                    sub.push(_sub);
                }
            });
            filtered.push(sub);
        }
    });
    return filtered;
}